import axiosClient from "../../utils/axiosClient"
import { API_URLs } from "../../constants/api_urls"
import { UserData } from "../../redux-stores/slices/authSlice";
import { apiConfigs } from "../../constants/apiConfigs";

export const generateOTP = async (data: { mode: string, username: string }): Promise<{status: boolean, mode?: string}> => {
    const response = await axiosClient.post(API_URLs.GENERATE_OTP, data);
    return response.data;
}

export const verifyOTP = async (data: {username:string, otp: string}): Promise<any> => {
    const response = await axiosClient.post(API_URLs.LOGIN, data);
    return response.data;
}

export const fetchUser = async (token:string) : Promise<UserData> => {
    const response = await axiosClient.get(API_URLs.GET_USER_PROFILE, {headers: {Authorization: `Bearer ${token}`}});
    return response.data as UserData;
}


export const registerUser = async (data: {username: string, otp: string, name: string, referrer?: string | null}) : Promise<any> => {
    const response = await axiosClient.post(API_URLs.REGISTER, data);
    return response.data;
}

export const debug = async (data: any) => {
    const response = await axiosClient.post('/debug', data);
    return response.data;
}

export const submitIGHandle = async (data: any) => {
    const response = await axiosClient.post(apiConfigs.SUBMIT_IG_HANDLE.url, data);
    return response.data;
}

export const fetchIGHandleVerificationStatus = async (data: any = {}) => {
    const response = await axiosClient.post(apiConfigs.FETCH_IG_HANDLE_VERIFICATION_STATUS.url, data);
    return response.data;
}